import createDocument from "../../utils/createDocument";
import createDocumentData from "../../utils/createDocumentData";

import { ExportPreset } from "./types/ExportPreset";

export default function createExportPreset(firebase, data) {
	const channel = ExportPreset.parse(createDocumentData(firebase, "exportPresets", data));

	return createDocument(channel);
}
